import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function IncludedFeatures() {
  const features = ['Full case briefing document', 'Evidence files and photographs', 'Suspect profiles and interview transcripts', 'Timeline reconstruction sheets', 'Red herring warnings — nothing is what it seems', 'Team rolecard assignments', 'Hint system for when you get stuck', 'Sealed solution and full case debrief', 'Replay guide — try a different theory'];
  return <section className="py-16 sm:py-24 lg:py-32 bg-[#0a0a0a] relative" data-id="element-211">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 sm:mb-16" data-id="element-213">
          <h2 className="font-typewriter text-2xl sm:text-5xl text-[#ece3d0] mb-3 sm:mb-6 drop-shadow-lg" data-id="element-214">
            Everything included in every case
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-[#ece3d0] bg-paper-texture rounded shadow-2xl p-6 sm:p-12 border border-[#d4c5b0] relative" data-id="element-215">
          {/* Tape detail */}
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-24 h-8 bg-white/40 backdrop-blur-sm rotate-[-1deg] shadow-sm" data-id="element-216" />

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 sm:gap-y-6" data-id="element-217">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="flex items-start space-x-3 sm:space-x-4 border-b border-[#1a1a1a]/10 pb-3 sm:pb-4" data-id="element-218">
                <div className="w-5 h-5 sm:w-6 sm:h-6 rounded bg-[#8b1a1a]/10 flex items-center justify-center shrink-0 mt-0.5 border border-[#8b1a1a]/20" data-id="element-219">
                  <CheckIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#8b1a1a]" data-id="element-220" />
                </div>
                <span className="font-serif-body text-[#1a1a1a] text-base sm:text-lg leading-snug" data-id="element-221">
                  {feature}
                </span>
              </motion.div>)}
          </div>

          <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t-2 border-dashed border-[#1a1a1a]/20 text-center" data-id="element-222">
            <p className="font-typewriter text-[#1a1a1a] text-sm sm:text-base font-bold tracking-wider uppercase" data-id="element-223">
              Designed for 2 to 6 players. Print once, play together.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}